import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "./Features/Auth/AuthSlice";
import channelSlice from "./Features/Channel/ChannelSlice";
import singleChannelSlice from "./Features/SingleChannel/SingleChannelSlice";
import productsSlice from "./Features/Product/productSlice";
import singleProductSlice from "./Features/SingleProduct/SingleProduct";
import ordersSlice from "./Features/Order/orderSlice";
import singleOrderSlice from "./Features/SingleOrder/SingleOrder";
import singleChannelWebhooks from "./Features/WebHooks/SingleChannelHooks";
import usersSlice from "./Features/Users/UserSlice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    channel: channelSlice.reducer,
    singleChannelSlice: singleChannelSlice.reducer,
    productsSlice: productsSlice.reducer,
    singleProductSlice: singleProductSlice.reducer,
    ordersSlice: ordersSlice.reducer,
    singleOrderSlice: singleOrderSlice.reducer,
    singleChannelWebhooks: singleChannelWebhooks.reducer,
    usersSlice: usersSlice.reducer
  }
});


export default store;